import { useState, useMemo } from 'react';
import { SelectBox } from '@/components/SelectBox';

const SelectDepartamentoProvinciaDistrito = ({
  departamentos = [],
  provincias = [],
  distritos = [],
  check,
  onChange
}) => {
  const [selectedDepartamento, setSelectedDepartamento] = useState('');
  const [selectedProvincia, setSelectedProvincia] = useState('');
  const [selectedDistrito, setSelectedDistrito] = useState('');

  const provinciasCurr = useMemo(() => {
    return provincias
      .filter((provincia) => provincia.department === selectedDepartamento)
      .map((x) => ({
        value: x.id,
        text: x.name
      }));
  }, [selectedDepartamento, provincias]);

  const distritosCurr = useMemo(() => {
    return distritos
      .filter((distrito) => distrito.province_id === selectedProvincia)
      .map((x) => ({
        value: x.name,
        text: x.name
      }));
  }, [selectedProvincia, distritos]);

  const departamentosCurr = useMemo(() => {
    return departamentos.map((x) => ({
      value: x.name,
      text: x.name
    }));
  }, [departamentos]);

  const handleDepartamentoChange = (e) => {
    if (selectedDepartamento !== e.value) {
      setSelectedProvincia('');
      setSelectedDistrito('');
      onChange({
        target: {
          name: 'provincia',
          value: '',
          text: ''
        }
      });
      onChange({
        target: {
          name: 'distrito',
          value: '',
          text: ''
        }
      });
    }

    setSelectedDepartamento(e.value);
    onChange({
      target: {
        name: 'departamento',
        value: e.value,
        text: e.label
      }
    });
  };

  const handleProvinciaChange = (e) => {
    if (selectedProvincia !== e.value) {
      setSelectedDistrito('');
      onChange({
        target: {
          name: 'distrito',
          value: '',
          text: ''
        }
      });
    }

    setSelectedProvincia(e.value);
    onChange({
      target: {
        name: 'provincia',
        value: e.value,
        text: e.label
      }
    });
  };

  const handleDistritoChange = (e) => {
    setSelectedDistrito(e.value);
    onChange({
      target: {
        name: 'distrito',
        value: e.value,
        text: e.label
      }
    });
  };

  return (
    <div className="flex flex-col sm:flex-row items-center sm:mb-24">
      <div className="w-full sm:mr-9 mb-20 sm:mb-0">
        <SelectBox
          title="Departamento"
          validation={check}
          name="departamento"
          value={selectedDepartamento}
          onChange={handleDepartamentoChange}
          options={departamentosCurr}
          placeholder="Seleccione un departamento"
        />
      </div>
      <div className="w-full sm:ml-9 mb-20 sm:mb-0">
        <SelectBox
          title="Provincia"
          validation={check}
          name="provincia"
          value={selectedProvincia}
          onChange={handleProvinciaChange}
          options={provinciasCurr}
          placeholder="Seleccione una provincia"
        />
      </div>
      <div className="w-full sm:ml-9 mb-20 sm:mb-0">
        <SelectBox
          title="Distrito"
          validation={check}
          name="distrito"
          value={selectedDistrito}
          onChange={handleDistritoChange}
          options={distritosCurr}
          placeholder="Seleccione un distrito"
        />
      </div>
    </div>
  );
};

export default SelectDepartamentoProvinciaDistrito;
